const MenuToggle = (el) => {
    const $el = $(el)
    $el.click(() => {
        $('body').toggleClass('js-state-menu-open');
    })
    
}

export { MenuToggle }